<template>
<v-main class="pa-5 pb-4">

  <v-flex>

    <v-card>
      <v-card-title>
        <v-toolbar-title>Locais da Unidade
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" no-data-text="Nenhum item disponível" :items="listaLocais" :search="search">
        <template v-slot:items="props">
          <td class="title">{{ props.item.nomeLocal}}</td>
          <!-- <td class="text-xs-right">{{ props.item.idUnidade }}</td> -->

          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab v-bind="attrs" v-on="on" elevation="1" @click="alterarDadosLocal(props.item)">
                  <v-icon color="success" small >
                    edit
                  </v-icon>
                </v-btn>
              </template>
              <span>Alterar nome </span>
            </v-tooltip>

          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab v-bind="attrs" small v-on="on" elevation="1" @click="alterarDadosLocal(item)">
                <v-icon color="success" small>
                  edit
                </v-icon>
              </v-btn>
            </template>
            <span>Alterar dados do local</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">
            Reset
          </v-btn>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <v-layout style="height: 90px; position: relative" right bottom>
    <v-btn id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click="" :to="{path:'/cadastrarLocalUnidade'}">
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaAdministrador',
  data () {
    return {
      page: 1,
      search: '',
      isEditing: true,
      headers: [{
        text: 'Nome do Local',
        align: 'center',
        sortable: true,
        value: 'nomeLocal'
      },
      // { text: 'unidade Administrada', value: 'id' },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false
      }
        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        // { text: 'Iron (%)', value: 'iron' }
      ],
      listaLocais: [],
      user: null,
      items: [{
        nomeLocal: 'aaa!',
        idLocal: '1'
      },
      {
        nomeLocal: 'bbb',
        idLocal: '3'
      },
      {
        nomeLocal: 'ccc',
        idLocal: '2'
      },
      {
        nomeLocal: 'ddd',
        idLocal: '15'
      },
      {
        nomeLocal: 'eee',
        idLocal: '31'
      },
      {
        nomeLocal: 'fff',
        idLocal: '22'
      }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarLocais()
  },
  methods: {

    deletarLocal (item) {
      console.log('em deletar local...')
      console.log(item)
    },

    alterarDadosLocal (item) {
      console.log('em editar local...')
      this.$router.push({
        name: 'alterarDadosLocal',
        params: {
          item: item
        }
      })
    },

    retornarLocais () {
      console.log('em retornar unidades adm...')
      administradorUnidadeService.administradorUnidade
        .retornarLocais()
        .then(rsp => {
          console.log('rsp oi:')
          this.listaLocais = rsp.data
          console.log(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    }
  },
  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
